import { z } from 'zod';

import i18n from '@/lib/i18n/i18n';

const { t } = i18n;

export const contactInnovationTeamValidationSchema = z.object({
  department: z
    .string()
    .trim()
    .min(1, t`contact-innovation-team:validation.department.required`),
  email: z
    .string()
    .trim()
    .min(1, t`contact-innovation-team:validation.email.required`)
    .email(t`contact-innovation-team:validation.email.invalid`),
  message: z
    .string()
    .trim()
    .min(1, t`contact-innovation-team:validation.message.required`),
  name: z
    .string()
    .trim()
    .min(1, t`contact-innovation-team:validation.name.required`),
});

export type ContactInnovationTeamFormData = z.infer<
  typeof contactInnovationTeamValidationSchema
>;
